import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetHypothesisParams } from '@/shared/api/end-points/hypothesis'
import { HypothesisResponse } from '../../lib'

const getone = async (params: GetHypothesisParams) => {
  return await api.json<HypothesisResponse>(API_END_POINTS.hypothesis.getHypothesis(params))
}

export default getone
